import { SMS_CODE_LENGTH } from '~/shared/config/constants'

export const extractSMSCode = (
  message: string,
  length = SMS_CODE_LENGTH,
): string | null => {
  const regex = new RegExp(`\\d{${length}}`)
  return message.match(regex)?.[0] || null
}
